import { routeHistoryReducer } from './RouteHistory';
import { trackingReducer } from './Tracking';
import { TrackingSagasListener } from './Tracking/sagas';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';

const sagaMiddleware = createSagaMiddleware();
const middleware = applyMiddleware(sagaMiddleware);

export const trackingStoreReducer = combineReducers({
  tracking: trackingReducer,
  routesHistory: routeHistoryReducer,
});

export const trackingStore = createStore(
  trackingStoreReducer,
  compose(middleware)
);
[TrackingSagasListener].forEach(sagaMiddleware.run);

export type TrackingState = ReturnType<typeof trackingStoreReducer>;
